import React from 'react';
import ReactDOM from 'react-dom';
const css = require('./index.scss');
import {
  Icon
} from 'antd';

class Test {
  title?: string;
  operates?: any = [];
  // operates?: [
  //   {
  //     type: string;
  //     event: () => void;
  //   }
  // ];
}

export default class LineOperae extends React.PureComponent<Test> {
  constructor (props: any) {
    super(props);
  }

  render () {
    const { title, operates } = this.props;
    return (
      <div className={css['separation']}>
        {title && <h6>{title}</h6>}
        <hr className={css['separation-hr']}/>
        {
          operates && operates.map((el, i) => {
            const right = i * 32 + (i) * 10;
            el.right = right;
            return <this.operateIcon key={right} operate={el}/>;
          })
        }
      </div>
    );
  }

  private operateIcon = (props) => {
    const { right, type, event } = props.operate;
    return (
      <div onClick={() => {event(true);}} className={css['separation-operate']} style={{right: `${right}px`}}>
        <Icon type={type}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/component/lineOperate/index.tsx